import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/workspace/$workspaceSlug/products/")({
  loader: ({ params }) => {
    throw redirect({
      to: "/workspace/$workspaceSlug/knowledge/products",
      params: { workspaceSlug: params.workspaceSlug },
    });
  },
});
